import type { CategorizationRule } from './types';

// Priority rules - exact matching (transfers, payments are critical)
export const PRIORITY_RULES: CategorizationRule[] = [
  {
    category: "Credit Card Payment",
    types: ["Payment", "DIRECT_PAY"],
    keywords: [
      "automatic payment",
      "autopay payment",
      "cardmember serv",
      "amex epayment",
      "chase credit",
      "chase cc",
      "credit card payment",
    ],
  },
  {
    category: "Credit Card Payment",
    keywords: [
      "payment made by account ending",
      "payment thank you",
      "bk of amer visa",
      "wf credit card",
      "wells fargo card",
      "discover",
      "citi autopay",
      "citi card",
      "barclaycard",
    ],
  },
  {
    category: "Transfer",
    keywords: [
      "webxfr",
      "web xfr",
      "online transfer",
      "transfer from",
      "transfer to",
      "transfer ",
      "us bank transfer",
      "huntington bank",
      "wells fargo ifi",
    ],
  },
  {
    category: "Transfer",
    requiresMultiple: [
      ["from ", "to "],
      ["checking", "savings", "account"],
    ],
    keywords: [],
  },
  {
    category: "Transfer",
    requiresMultiple: [
      ["from ", "to "],
      ["chase", "bmo", "sofi", "fidelity", "usbank", "us bank", "amex", "wells fargo"],
    ],
    keywords: [],
  },
  {
    category: "Transfer",
    requiresMultiple: [["from ", "to "], ["vault"]],
    keywords: ["from emergency", "to emergency", "from sharing", "to sharing", "from checking", "to checking"],
  },
  {
    category: "Transfer",
    types: ["ACCT_XFER", "Withdrawal"],
    keywords: [],
  },
];
